import React, { useState } from "react";
import TextInput from "../../../components/TextInput";
import SearchButton from "../../../components/SearchButton";
import RefreshButton from "../../../components/RefreshButton";
import { BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Disclosure } from "@headlessui/react";

const TableFilters = ({
  filterText,
  columnDetails,
  moduleDetails,
  textInputName,
  disabledButton,
}) => {
  const [inputValue, setInputValue] = useState("");

  const FilterData = () => {
    filterText(inputValue);
  };
  const DoNothing = () => {};
  return (
    <div>
      <div className="flex flex-row w-full items-center gap-2">
        <TextInput
          type={textInputName}
          name={textInputName}
          placeholder={columnDetails}
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            e.target.value === "" ? filterText("") : DoNothing();
          }}
        />
        <div className="flex justify-center items-end gap-x-2 rounded-md">
          <SearchButton
            buttonValue="Search"
            className={
              inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
            }
            disabled={inputValue === "" || disabledButton ? true : false}
            onClick={() => {
              FilterData();
            }}
          />
          <RefreshButton
            className={
              inputValue === "" || disabledButton ? "opacity-50" : "opacity-100"
            }
            disabled={inputValue === "" || disabledButton ? true : false}
            onClick={() => {
              if (!disabledButton) {
                filterText("");
                setInputValue("");
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TableFilters;
